import { useLocation } from '@react-router';
import { useMemo } from 'react';

export const SHOW_SEARCH_SCORES_PARAM = 'showSearchScores';

/**
 * Debug flag that reveals per-tile search similarity scores in the designs
 * gallery, so engineers can see why a template ranked where it did.
 *
 * Presence is what counts — `?showSearchScores` and `?showSearchScores=1` both
 * enable it — so this checks `has()` rather than reading a value. Explicitly
 * opt out with `?showSearchScores=0` / `=false`.
 *
 * Not a secret: it exposes no sensitive data and needs no auth. It's simply
 * kept off the default UI so scores aren't shown to shoppers.
 */
export function useShowSearchScores(): boolean {
  const { search } = useLocation();

  return useMemo(() => {
    const params = new URLSearchParams(search);
    if (!params.has(SHOW_SEARCH_SCORES_PARAM)) return false;

    const value = params.get(SHOW_SEARCH_SCORES_PARAM);
    return value !== '0' && value !== 'false';
  }, [search]);
}
